import { render, staticRenderFns } from "./EditLastContact.vue?vue&type=template&id=7ee04b15&"
import script from "./EditLastContact.vue?vue&type=script&lang=js&"
export * from "./EditLastContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports